import { NumberFormatType } from 'common/building-blocks/text/constants';
import type { NumberFormatConfig } from 'common/building-blocks/text/constants';

export function createDefaultConfig(type: NumberFormatType): NumberFormatConfig {
	switch (type) {
		case NumberFormatType.None:
			return {
				type: NumberFormatType.None,
			};

		case NumberFormatType.Compact:
			return {
				type: NumberFormatType.Compact,
			};

		case NumberFormatType.Percent:
			return {
				type: NumberFormatType.Percent,
			};

		case NumberFormatType.CommaSeparated:
			return {
				type: NumberFormatType.CommaSeparated,
			};

		case NumberFormatType.Custom:
			return {
				type: NumberFormatType.Custom,
				delimiter: 'comma',
				precision: '2',
				unit: '',
				unitPosition: 'before',
				compact: false,
			};

		default:
			throw new Error(`Unknown number format type: ${type}`);
	}
}
